import { Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface WorkspaceUnsavedChangesModalProps {
  open: boolean
  onStay: () => void
  onDiscard: () => void
}

function WorkspaceUnsavedChangesModal({
  open,
  onStay,
  onDiscard
}: WorkspaceUnsavedChangesModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      centered
      destroyOnHidden
      open={open}
      title={t("leadWorkspace.unsavedChanges.title")}
      okText={t("leadWorkspace.unsavedChanges.discard")}
      cancelText={t("leadWorkspace.unsavedChanges.stay")}
      okButtonProps={{ danger: true }}
      onOk={onDiscard}
      onCancel={onStay}
    >
      <p>{t("leadWorkspace.unsavedChanges.content")}</p>
    </Modal>
  )
}

export { WorkspaceUnsavedChangesModal }
